
//1.修改router index.js 去掉路由拦截
//2.修改store index.js 修改token 为自动获取的内容
//3.修改config 微信appid为正式
//4.主要api all.js 地址是否正确

//正式域名
export const hostUrl = 'leveledreading.huojianmao.com'
//base路径
export const BASEPATH = ''
// 微信appid
export const weixinAppId = 'wx5d20d700ddc6b484'
// export const weixinAppId = 'wx48dacf1b6e25d3e3'

const ORIGIN = location.origin
export const weixinShareParams = {
  title: '火箭猫英语 剑桥英语学堂',  // 分享标题
  desc: '名校敲门砖,口语满分课1元领',  // 分享描述
  link: location.href,  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: 'https://oss-rocketcat.oss-cn-beijing.aliyuncs.com/punchTheClockCamp/shareImage/shareIcon.png',  // 分享图标
}

// export const ARTICLE_PROCESS_STEPS = [
//   {
//     processStatus : 1,
//     label : '背景视频',
//     route : '/home'
//   },
//   {
//     processStatus : 2,
//     label : '阅读文章',
//     route : '/articleDetail'
//   },
//   {
//     processStatus : 3,
//     label : '阅读检测',
//     route : '/articleQuiz'
//   },
//   {
//     processStatus : 4,
//     label : '错题解析',
//     route : '/answerAnalysis'
//   }
// ];




//////////////////
// WEBPACK FOOTER
// ./app/config/index.js
// module id = null
// module chunks = 